<template>
    <div id="blank-page-1">
        <router-view></router-view>
    </div>
</template>

<script>

    export default {
        name: "Empty1",

        data() {
            return {};
        },
        components: {
            
        },
        computed: {
            isLoading() {
                return this.$store.getters.isLoading
            },
            user_info() {
                return this.$store.state.user_info;
            }
        },

        methods: {
            fetch() {

            },
        }
    }
</script>

<style scoped>
   #blank-page-1{
    background: #fff;
   }
</style>